import styled from "styled-components";

export const GlossaryModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GlossaryItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f5f9fb;
  padding: 16px;
  border-radius: 16px;
`;

export const FormulaContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  padding: 8px 16px;
  background-color: white;
  border-radius: 8px;
`;

export const GlossaryListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
